import React from 'react';
import { useRegisterStatus, humanFreshness } from '../context/RegisterStatus';
import { RefreshCw, AlertTriangle } from 'lucide-react';

export function RegisterFreshness({ compact = false }) {
  const s = useRegisterStatus();
  if (!s) return null;
  const label = s.status?.last_read_at ? humanFreshness(s.freshness) : 'connecting…';
  const stale = s.isStale;
  const tone = stale ? { color: '#B26A00', bg: '#FFF3E0' } : { color: '#1F5A24', bg: '#E8F5E9' };
  return (
    <button
      data-testid="register-refresh"
      onClick={s.refresh}
      disabled={s.refreshing}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium border transition-colors ${compact ? '' : 'sm:text-sm'}`}
      style={{ background: tone.bg, color: tone.color, borderColor: stale ? '#B26A00' : '#C8E6C9' }}
      title="Refresh from the booking register"
    >
      <RefreshCw size={13} className={s.refreshing ? 'animate-spin' : ''} />
      <span>updated {label}</span>
    </button>
  );
}

export function StaleBanner() {
  const s = useRegisterStatus();
  if (!s?.isStale) return null;
  return (
    <div
      data-testid="stale-banner"
      role="alert"
      className="mb-4 px-4 py-3 rounded-xl border-2 border-[#B26A00] bg-[#FFF3E0] text-[#8f5500] flex items-start gap-3"
    >
      <AlertTriangle size={20} className="mt-0.5 shrink-0 text-[#B26A00]" />
      <div className="flex-1">
        <div className="font-medium">The booking register may be out of date.</div>
        <div className="text-sm">The list you're seeing is the last one we could load. Check-in and payment actions are paused until the connection is back.</div>
      </div>
      <button
        onClick={s.refresh}
        disabled={s.refreshing}
        className="shrink-0 px-3 py-2 rounded-lg bg-[#B26A00] hover:bg-[#8f5500] text-white text-sm font-medium disabled:opacity-60"
      >
        Try again
      </button>
    </div>
  );
}
